'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LogSearch = exports.LogSearch = function () {
	/**
  * @param {LogProvider} provider
  */
	function LogSearch(provider) {
		_classCallCheck(this, LogSearch);

		this.provider = provider;
		this.initialize();
	}

	_createClass(LogSearch, [{
		key: 'initialize',
		value: function initialize() {
			OC.Plugins.register('OCA.Search', this);
		}
	}, {
		key: 'attach',
		value: function attach(search) {
			var _this = this;

			search.setFilter('settings', _.debounce(function (query) {
				if (query.length >= 3 || query == '') {
					_this.provider.query = query;
				}
			}, 250));
		}
	}]);

	return LogSearch;
}();


//////////////////
// WEBPACK FOOTER
// ./js/Search.js
// module id = 651
// module chunks = 0